var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40.313 44.344",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.235,5H26.156a10.079,10.079,0,0,0-9.877,8.065l-.2,0A10.078,10.078,0,0,0,6,23.141V39.266A10.078,10.078,0,0,0,16.078,49.344H26.156a10.079,10.079,0,0,0,9.877-8.065l.2,0A10.078,10.078,0,0,0,46.313,31.2V15.078A10.078,10.078,0,0,0,36.235,5ZM32.2,39.266a6.047,6.047,0,0,1-6.047,6.047H16.078a6.047,6.047,0,0,1-6.047-6.047V23.141a6.047,6.047,0,0,1,6.047-6.047H26.156A6.047,6.047,0,0,1,32.2,23.141ZM42.281,31.2a6.047,6.047,0,0,1-6.047,6.047V23.141A10.078,10.078,0,0,0,26.156,13.063h-5.7a6.047,6.047,0,0,1,5.7-4.031H36.235a6.047,6.047,0,0,1,6.047,6.047Z",
    transform: "translate(-6 -5)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.e7989f80.svg";
export { ForwardRef as ReactComponent };